import { FeatureFlagValue, FlagEnvironment } from './types';

/** Flags are namespaced per service on the BFF - `ace-web.maintenance`. */
export const FLAG_KEY_PREFIX = 'ace-web.';

export const CROSS_FLAG_KEY_PREFIX = 'cross.';

export const FLAGS_API_PATH = '/api/v1/environments';

export const FLAG_UPDATED_EVENT = 'flag-updated';

export const ACE_WEB_LOCAL_CLIENT_ID = 'aceportallocal';

export const DISABLED_FLAG: FeatureFlagValue = { enabled: false, value: null };

export const FLAG_ENVIRONMENT_BY_CURRENT_ENV: Record<string, FlagEnvironment> = {
  dev: FlagEnvironment.DEV,
  test: FlagEnvironment.TEST,
  uat: FlagEnvironment.UAT,
  prod: FlagEnvironment.PROD,
};

export const FLAG_ENVIRONMENTS = new Set<string>(Object.values(FlagEnvironment));
